/*
 * サブシステム名：マスタ管理
 * 機能名：区分マスタ登録
 */
// import DdFooterButton from '@/components/DdFooterButton'
import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

import flowMixin from '@/mixins/flowMixins'

import { mapGetters } from 'vuex'

const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')
const DdCheckbox = () => import('@/components/DdCheckbox')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdHimodukeHaishahyoAddButton = () => import('@/components/DdHimodukeHaishahyoAddButton')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')

export default {
  name: 'MstKubunEdit',
  mixins: [flowMixin],
  data: () => ({
    id: 0,
    rec: {},
    invalidMessages: {},
    modeOfEdit: 2,
    modeKengen: 2,
    showCopyDialog: false
  }),
  components: {
    DdSubHeader,
    DdTextBox,
    // DdFooterButton,
    DdCheckbox,
    DdNumericBox,
    DdHimodukeHaishahyoAddButton,
    DdIconButtonWithTooltip,
    DdCustomButton,
    DdTransparentButton
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      kubunshubetsushuruiList: 'DDMasters/msysKubunShubetsuShurui'
    }),
    filteredKubunShubetsuShurui () {
      return this.kubunshubetsushuruiList.filter(function (elem) {
        return elem.kbnSbtKbn === 'K'
      }).map(function (elem) {
        elem.value = elem.kbnSbtShuruiCd
        elem.text = elem.kbnSbtShuruiNm
        return elem
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.kbnSbtShuruiCd > elem2.kbnSbtShuruiCd) { return 1 }
        if (elem1.kbnSbtShuruiCd === elem2.kbnSbtShuruiCd) { return 0 }
        return -1
      })
    },
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isSaveDisable () {
      return this.id === 0
    },
    isCancelButtonDisplay () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return false
      }
      return true
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    }
  },
  created () {
    this.id = this.$route.params.id
    if (this.id === '0') {
      this.id = 0
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    getCloneTargetMethod: function () {
      return this.rec
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }

      this.preventTransition(opt)
    },
    fetchData: function () {
      const self = this
      return new Promise((resolve) => {
        console.log(self.id)
        this.HttpClient
          .get(`/api/v1/msyskubun/find?id=${self.id}`)
          .then((data) => {
            self.rec = data.payload
            var kbnSbtShurui = self.filteredKubunShubetsuShurui.find((elem) => elem.value === self.rec.kbnShuruiCd)
            if (kbnSbtShurui !== undefined) {
              self.rec.kbnSbtShuruiNm = kbnSbtShurui.text
            }
            resolve()
          })
      })
    },
    initialize () {
      const self = this
      const option = {
        loadMasters: ['msyskubunshubetsushurui'],
        initializeInputPromise: () => {
          return new Promise((resolve) => {
            self.rec = {}
            resolve()
          })
        },
        savedInputRestorePromise: () => {
          return new Promise((resolve) => {
            console.log('savedInputRestorePromise')
            resolve()
          })
        },
        existsIdMethod: () => {
          return self.id !== 0
        },
        requestApiPromise: self.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (self.id === 0) {
              self.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              self.modeOfEdit = 1 // 照会モード
            } else {
              self.modeOfEdit = 2 // 更新モード
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          console.log('settingItemMethod', kengen)
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = data()
            self.rec.id = self.id
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },
    onSaveButtonClick: function (e) {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            this.id = id
            this.transition(1, { id: id }, this.initialize)
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          return {}
        }
      }

      this.register(opt)
    },
    registerPromise: function () {
      let f
      if (this.id === 0) {
        // f = this.HttpClient.post('/api/v1/msyskubun/create', this.rec)
      } else {
        f = this.HttpClient.put(`/api/v1/msyskubun/update?id=${this.id}`, this.rec)
      }
      return f
    },
    registerValidate: function () {
      return true
    },
    deleteValidate: function () {
      return true
    },
    copyToSeisikiNm: function () {
      this.rec.codeSeishikiNm = this.rec.codeNm
    }
  }
}
